'use strict';

import modalDirective from 'brg/rest/buttons/modal';

import template from './template.html';

export default modalDirective({
	template: template,
	controller: controller,
});


function controller($scope, $http) {
	'ngInject';

	$scope.submitting = false;
	$scope.errors = null;

	$scope.submitData = function() {
		if ($scope.submitting) return;
		$scope.submitting = true;
		$http({
			method: 'POST',
			url: '/api/escalation/delete_profile',
			data: {
				'profile_uuid': $scope.$context.profileID,
			},
		}).then((response) => {
			$scope.$close({
				responseData: response.data,
				context: $scope.$context,
			});
		}, (error) => {
			console.error(error);
			$scope.errors = error.data;
		}).finally(() => {
			$scope.submitting = false;
		});
	}
}
